import styled from 'styled-components';

export const SponsorsContainer = styled.div`
  max-width: 80%;
  margin: 0 auto;
  padding: .5rem 1rem;
`;

export const SponsorCard = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
`;

export const SponsorContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  padding: 0 32px; 
  box-sizing: border-box;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0 4px; 
  }
`;

export const SponsorText = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-right: 2rem;
  font-size: 1.2rem;
  padding-left: 2rem;
  word-break: break-word;
  overflow-wrap: break-word;

  @media (max-width: 768px) {
    width: 100%;
    padding-left: 0;
    margin-right: 0;
    margin-top: 1rem;
    font-size: 1rem;
    text-align: center;
    justify-content: center;
  }
`;

export const SponsorLogo = styled.div`
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
  }

    @media (max-width: 768px) {
    width: 120px;
    height: 120px;
  }
`;

export const SideButton = styled.button`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 40px; /* Adjust width as needed */
  height: 100%;
  background: transparent;
  color: #bbb;
  border: none;
  font-size: 2.5rem;
  cursor: pointer;
  z-index: 2;
  transition: color 0.2s, background 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #888;
    background: rgba(0,0,0,0.05); /* subtle hover effect */
  }
`;

export const PrevButton = styled(SideButton)`
  left: 0;
  border-radius: 8px 0 0 8px;
`;

export const NextButton = styled(SideButton)`
  right: 0;
  border-radius: 0 8px 8px 0;
`;